import CtaIcon from '../ui/CtaIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { cardRequest, type CardHub } from '../../services/api/passportCards';
import { PassportScanButton } from '../passport/PassportHub';
export function CollectorHome() {
  const { user } = useAuth();
  const [result, setResult] = useState<{ owner: number; hub: CardHub } | null>(null);
  useEffect(() => {
    let active = true;
    if (user)
      void cardRequest<CardHub>('hub')
        .then((hub) => {
          if (active) setResult({ owner: Number(user.id), hub });
        })
        .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [user]);
  const hub = result?.owner === Number(user?.id) ? result?.hub : null;
  return (
    <section id="home-collection" className="mb-6 border-y border-white/15 py-8">
      <p className="text-sm text-orange-300">Your Bilt Passport</p>
      <h2 className="mt-2 font-display text-3xl text-white">
        {hub?.stats.vehicle
          ? `${hub.stats.vehicle} cars worth remembering.`
          : 'Your next great find is out there.'}
      </h2>
      <p className="mt-3 text-zinc-300">
        Scan a Bilt QR, keep its card, and discover the story behind it. A Garage is optional.
      </p>
      <div className="pc-actions mt-5">
        <PassportScanButton />
        <Link className="pc-link" to="/passport">
          Open Passport <CtaIcon direction="open" />
        </Link>
      </div>
    </section>
  );
}
